export const realProperties = [
  {
    "id": "PROP-001",
    "name": "Ganesh Angan",
    "location": "Akurdi, Pune",
    "address": "Ganesh Angan, Akurdi, Pune",
    "googleRating": "3.5 ⭐",
    "photos": [
      "/Property Pic/Ganesh Angan/ganesh-angan-hall.jpeg",
      "/Property Pic/Ganesh Angan/ganesh-angan-bedroom-1.jpeg",
      "/Property Pic/Ganesh Angan/ganesh-angan-bedroom-2.jpeg",
      "/Property Pic/Ganesh Angan/ganesh-angan-bedroom-3.jpeg",
      "/Property Pic/Ganesh Angan/ganesh-angan-bedroom-4.jpeg",
      "/Property Pic/Ganesh Angan/ganesh-angan-kitchen.jpeg"
    ],
    "flats": [
      {
        "flatNumber": "Flat 101",
        "flatType": "2BHK",
        "floor": "1th Floor",
        "rooms": [
          {
            "roomId": "GA-101-R1",
            "roomType": "Common Bed Room",
            "capacity": 2,
            "rentPerBed": 6500,
            "securityDeposit": 13000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "GA-101-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "GA-101-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 102",
        "flatType": "2BHK",
        "floor": "2th Floor",
        "rooms": [
          {
            "roomId": "GA-102-R1",
            "roomType": "Harmony Hall",
            "capacity": 2,
            "rentPerBed": 5500,
            "securityDeposit": 11000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "GA-102-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "GA-102-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 103",
        "flatType": "2BHK",
        "floor": "3th Floor",
        "rooms": [
          {
            "roomId": "GA-103-R1",
            "roomType": "Queen Bedroom",
            "capacity": 2,
            "rentPerBed": 7000,
            "securityDeposit": 14000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "GA-103-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "GA-103-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      }
    ],
    "totalFlats": 3,
    "totalBeds": 6
  },
  {
    "id": "PROP-002",
    "name": "Swami Residency",
    "location": "Nigdi Pradhikaran, Pune",
    "address": "Swami Residency, Nigdi Pradhikaran, Pune",
    "googleRating": "4.5 ⭐",
    "photos": [
      "/Property Pic/Swami Residency Bhelchowk/swami-residency-room-1.jpeg",
      "/Property Pic/Swami Residency Bhelchowk/swami-residency-living-room.jpeg",
      "/Property Pic/Swami Residency Bhelchowk/swami-residency-bedroom-2.jpeg",
      "/Property Pic/Swami Residency Bhelchowk/swami-residency-bedroom-3.jpeg",
      "/Property Pic/Swami Residency Bhelchowk/swami-residency-bed.jpeg",
      "/Property Pic/Swami Residency Bhelchowk/swami-residency-kitchen.jpeg"
    ],
    "flats": [
      {
        "flatNumber": "Flat 104",
        "flatType": "2BHK",
        "floor": "4th Floor",
        "rooms": [
          {
            "roomId": "SW-104-R1",
            "roomType": "Common Bed Room",
            "capacity": 2,
            "rentPerBed": 6500,
            "securityDeposit": 13000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SW-104-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SW-104-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          },
          {
            "roomId": "SW-104-R2",
            "roomType": "Harmony Hall",
            "capacity": 2,
            "rentPerBed": 5500,
            "securityDeposit": 11000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SW-104-R2-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SW-104-R2-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 101",
        "flatType": "2BHK",
        "floor": "1th Floor",
        "rooms": [
          {
            "roomId": "SW-101-R1",
            "roomType": "Harmony Hall",
            "capacity": 2,
            "rentPerBed": 5500,
            "securityDeposit": 11000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SW-101-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SW-101-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          },
          {
            "roomId": "SW-101-R2",
            "roomType": "Queen Bedroom",
            "capacity": 2,
            "rentPerBed": 7000,
            "securityDeposit": 14000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SW-101-R2-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SW-101-R2-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 102",
        "flatType": "2BHK",
        "floor": "2th Floor",
        "rooms": [
          {
            "roomId": "SW-102-R1",
            "roomType": "Queen Bedroom",
            "capacity": 2,
            "rentPerBed": 7000,
            "securityDeposit": 14000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SW-102-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SW-102-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          },
          {
            "roomId": "SW-102-R2",
            "roomType": "Elite Bedroom",
            "capacity": 2,
            "rentPerBed": 7000,
            "securityDeposit": 14000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SW-102-R2-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SW-102-R2-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 103",
        "flatType": "3BHK",
        "floor": "3th Floor",
        "rooms": [
          {
            "roomId": "SW-103-R1",
            "roomType": "Common Bed Room",
            "capacity": 2,
            "rentPerBed": 6500,
            "securityDeposit": 13000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SW-103-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SW-103-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      }
    ],
    "totalFlats": 4,
    "totalBeds": 14
  },
  {
    "id": "PROP-003",
    "name": "Casia Apartment",
    "location": "Nigdi, Pune",
    "address": "Casia Apartment, Nigdi, Pune",
    "googleRating": "4 ⭐",
    "photos": [
      "/Property Pic/Casia Apartment Both 2 BHK/Comman Bed Room.webp",
      "/Property Pic/Casia Apartment Both 2 BHK/Fridge.webp",
      "/Property Pic/Casia Apartment Both 2 BHK/Master Bed Room.webp",
      "/Property Pic/Casia Apartment Both 2 BHK/Utility Balcony.webp",
      "/Property Pic/Casia Apartment Both 2 BHK/Water Purifier.webp",
      "/Property Pic/Casia Apartment Both 2 BHK/kitchen.webp",
      "/Property Pic/Casia Apartment Both 2 BHK/kitchen_Plat Form.webp"
    ],
    "flats": [
      {
        "flatNumber": "Flat 103",
        "flatType": "2BHK",
        "floor": "3th Floor",
        "rooms": [
          {
            "roomId": "CA-103-R1",
            "roomType": "Common Bed Room",
            "capacity": 2,
            "rentPerBed": 6500,
            "securityDeposit": 13000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "CA-103-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "CA-103-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          },
          {
            "roomId": "CA-103-R2",
            "roomType": "Harmony Hall",
            "capacity": 2,
            "rentPerBed": 5500,
            "securityDeposit": 11000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "CA-103-R2-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "CA-103-R2-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 104",
        "flatType": "2BHK",
        "floor": "4th Floor",
        "rooms": [
          {
            "roomId": "CA-104-R1",
            "roomType": "Harmony Hall",
            "capacity": 2,
            "rentPerBed": 5500,
            "securityDeposit": 11000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "CA-104-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "CA-104-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          },
          {
            "roomId": "CA-104-R2",
            "roomType": "Queen Bedroom",
            "capacity": 2,
            "rentPerBed": 7000,
            "securityDeposit": 14000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "CA-104-R2-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "CA-104-R2-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 101",
        "flatType": "2BHK",
        "floor": "1th Floor",
        "rooms": [
          {
            "roomId": "CA-101-R1",
            "roomType": "Queen Bedroom",
            "capacity": 2,
            "rentPerBed": 7000,
            "securityDeposit": 14000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "CA-101-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "CA-101-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 102",
        "flatType": "2BHK",
        "floor": "2th Floor",
        "rooms": [
          {
            "roomId": "CA-102-R1",
            "roomType": "Common Bed Room",
            "capacity": 2,
            "rentPerBed": 6500,
            "securityDeposit": 13000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "CA-102-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "CA-102-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      }
    ],
    "totalFlats": 4,
    "totalBeds": 12
  },
  {
    "id": "PROP-004",
    "name": "Singh Apartment",
    "location": "Sambhaji Chowk, Pune",
    "address": "Singh Apartment, Sambhaji Chowk, Pune",
    "googleRating": "4 ⭐",
    "photos": [
      "/Property Pic/Singh Apart_3BHK & 2 BHK/Common Bed Room.webp",
      "/Property Pic/Singh Apart_3BHK & 2 BHK/Hall.webp",
      "/Property Pic/Singh Apart_3BHK & 2 BHK/Master Bed Room.webp",
      "/Property Pic/Singh Apart_3BHK & 2 BHK/Singh Apartment .webp"
    ],
    "flats": [
      {
        "flatNumber": "Flat 101",
        "flatType": "3BHK",
        "floor": "1th Floor",
        "rooms": [
          {
            "roomId": "SI-101-R1",
            "roomType": "Common Bed Room",
            "capacity": 2,
            "rentPerBed": 6500,
            "securityDeposit": 13000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SI-101-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SI-101-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          },
          {
            "roomId": "SI-101-R2",
            "roomType": "Elite Bedroom",
            "capacity": 2,
            "rentPerBed": 7000,
            "securityDeposit": 14000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SI-101-R2-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SI-101-R2-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 102",
        "flatType": "3BHK",
        "floor": "2th Floor",
        "rooms": [
          {
            "roomId": "SI-102-R1",
            "roomType": "Elite Bedroom",
            "capacity": 2,
            "rentPerBed": 7000,
            "securityDeposit": 14000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SI-102-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SI-102-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          },
          {
            "roomId": "SI-102-R2",
            "roomType": "Harmony Hall",
            "capacity": 2,
            "rentPerBed": 5500,
            "securityDeposit": 11000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SI-102-R2-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SI-102-R2-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 103",
        "flatType": "3BHK",
        "floor": "3th Floor",
        "rooms": [
          {
            "roomId": "SI-103-R1",
            "roomType": "Harmony Hall",
            "capacity": 2,
            "rentPerBed": 5500,
            "securityDeposit": 11000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SI-103-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SI-103-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          },
          {
            "roomId": "SI-103-R2",
            "roomType": "Common Bedroom",
            "capacity": 2,
            "rentPerBed": 7000,
            "securityDeposit": 14000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SI-103-R2-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SI-103-R2-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 104",
        "flatType": "3BHK",
        "floor": "4th Floor",
        "rooms": [
          {
            "roomId": "SI-104-R1",
            "roomType": "Queen Bedroom",
            "capacity": 2,
            "rentPerBed": 6500,
            "securityDeposit": 13000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "SI-104-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "SI-104-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      }
    ],
    "totalFlats": 4,
    "totalBeds": 14
  },
  {
    "id": "PROP-005",
    "name": "Unique K-Ville",
    "location": "Kiwale-Ravet, Pune",
    "address": "Unique K-Ville, Kiwale-Ravet, Pune",
    "googleRating": "5 ⭐",
    "photos": [
      "/Property Pic/Unique K-Ville/Hall.webp",
      "/Property Pic/Unique K-Ville/Common Bed Room.webp",
      "/Property Pic/Unique K-Ville/Fridge & Washing Auto Machine.webp",
      "/Property Pic/Unique K-Ville/Hall Galary View.webp",
      "/Property Pic/Unique K-Ville/Master Bed Room.webp",
      "/Property Pic/Unique K-Ville/Master Suite With Balcony.webp",
      "/Property Pic/Unique K-Ville/Modular Kitchen.webp",
      "/Property Pic/Unique K-Ville/Washroom.webp"
    ],
    "flats": [
      {
        "flatNumber": "Flat 104",
        "flatType": "3BHK",
        "floor": "4th Floor",
        "rooms": [
          {
            "roomId": "UN-104-R1",
            "roomType": "Elite Suite with Private Balcony",
            "capacity": 2,
            "rentPerBed": 8000,
            "securityDeposit": 16000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "UN-104-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "UN-104-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 101",
        "flatType": "3BHK",
        "floor": "1th Floor",
        "rooms": [
          {
            "roomId": "UN-101-R1",
            "roomType": "Common Bed Room",
            "capacity": 2,
            "rentPerBed": 7000,
            "securityDeposit": 14000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "UN-101-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "UN-101-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 102",
        "flatType": "3BHK",
        "floor": "2th Floor",
        "rooms": [
          {
            "roomId": "UN-102-R1",
            "roomType": "Harmony Hall",
            "capacity": 2,
            "rentPerBed": 6500,
            "securityDeposit": 13000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "UN-102-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "UN-102-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 103",
        "flatType": "3BHK",
        "floor": "3th Floor",
        "rooms": [
          {
            "roomId": "UN-103-R1",
            "roomType": "Queen Bedroom",
            "capacity": 2,
            "rentPerBed": 7500,
            "securityDeposit": 15000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "UN-103-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "UN-103-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      }
    ],
    "totalFlats": 4,
    "totalBeds": 8
  },
  {
    "id": "PROP-006",
    "name": "Eastern River Residency",
    "location": "Pimple Saudagar, Pune",
    "address": "Eastern River Residency, Pimple Saudagar, Pune",
    "googleRating": "5 ⭐",
    "photos": [
      "/Property Pic/Estern River Residency/Master Bed Room.webp",
      "/Property Pic/Estern River Residency/Common Bed Room.webp",
      "/Property Pic/Estern River Residency/Hall Common Balcony.webp",
      "/Property Pic/Estern River Residency/Hall.webp",
      "/Property Pic/Estern River Residency/Master Suite With Balcony.webp",
      "/Property Pic/Estern River Residency/Master Suite-Balcony.webp",
      "/Property Pic/Estern River Residency/Modular Kicthen.webp",
      "/Property Pic/Estern River Residency/Washroom Attached.webp",
      "/Property Pic/Estern River Residency/Washroom.webp"
    ],
    "flats": [
      {
        "flatNumber": "Flat 104",
        "flatType": "3BHK",
        "floor": "4th Floor",
        "rooms": [
          {
            "roomId": "EA-104-R1",
            "roomType": "Elite Suite with Private Balcony",
            "capacity": 2,
            "rentPerBed": 10000,
            "securityDeposit": 20000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "EA-104-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "EA-104-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 101",
        "flatType": "3BHK",
        "floor": "1th Floor",
        "rooms": [
          {
            "roomId": "EA-101-R1",
            "roomType": "Common Bed Room",
            "capacity": 2,
            "rentPerBed": 8000,
            "securityDeposit": 16000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "EA-101-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "EA-101-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 102",
        "flatType": "3BHK",
        "floor": "2th Floor",
        "rooms": [
          {
            "roomId": "EA-102-R1",
            "roomType": "Harmony Hall",
            "capacity": 2,
            "rentPerBed": 7500,
            "securityDeposit": 15000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "EA-102-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "EA-102-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 103",
        "flatType": "3BHK",
        "floor": "3th Floor",
        "rooms": [
          {
            "roomId": "EA-103-R1",
            "roomType": "Queen Bedroom",
            "capacity": 2,
            "rentPerBed": 9000,
            "securityDeposit": 18000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "EA-103-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "EA-103-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      }
    ],
    "totalFlats": 4,
    "totalBeds": 8
  },
  {
    "id": "PROP-007",
    "name": "Mantra Residency",
    "location": "Talwade-Nighoje, Pune",
    "address": "Mantra Residency, Talwade-Nighoje, Pune",
    "googleRating": "3.6 ⭐",
    "photos": [
      "/Property Pic/Mantra Residency flat/mantra-residency-living-room.webp",
      "/Property Pic/Mantra Residency flat/mantra-residency-bedroom-1.webp",
      "/Property Pic/Mantra Residency flat/mantra-residency-bedroom-2.webp",
      "/Property Pic/Mantra Residency flat/mantra-residency-balcony.webp",
      "/Property Pic/Mantra Residency flat/mantra-residency-kitchen.webp",
      "/Property Pic/Mantra Residency flat/mantra-residency-washroom.webp",
      "/Property Pic/Mantra Residency flat/mantra-residency-attached-washroom.webp"
    ],
    "flats": [
      {
        "flatNumber": "Flat 104",
        "flatType": "2BHK",
        "floor": "4th Floor",
        "rooms": [
          {
            "roomId": "MA-104-R1",
            "roomType": "Common Bed Room",
            "capacity": 2,
            "rentPerBed": 5000,
            "securityDeposit": 10000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "MA-104-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "MA-104-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 101",
        "flatType": "2BHK",
        "floor": "1th Floor",
        "rooms": [
          {
            "roomId": "MA-101-R1",
            "roomType": "Harmony Hall",
            "capacity": 1,
            "rentPerBed": 4000,
            "securityDeposit": 8000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "MA-101-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 102",
        "flatType": "2BHK",
        "floor": "2th Floor",
        "rooms": [
          {
            "roomId": "MA-102-R1",
            "roomType": "Queen Bedroom",
            "capacity": 2,
            "rentPerBed": 4500,
            "securityDeposit": 9000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "MA-102-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "MA-102-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      }
    ],
    "totalFlats": 3,
    "totalBeds": 5
  },
  {
    "id": "PROP-008",
    "name": "Rama Metro Life Maxima",
    "location": "Tathawade, Pune, Pune",
    "address": "Rama Metro Life Maxima, Tathawade, Pune, Pune",
    "googleRating": "5 ⭐",
    "photos": [
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-1.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-2.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-3.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-4.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-5.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-6.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-7.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-8.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-9.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-10.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-11.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-12.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-13.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-14.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-15.webp",
      "/Property Pic/metro_life_maxima/metro-life-maxima-apartment-16.webp"
    ],
    "flats": [
      {
        "flatNumber": "Flat 103",
        "flatType": "3BHK",
        "floor": "3th Floor",
        "rooms": [
          {
            "roomId": "RA-103-R1",
            "roomType": "Master Bedroom",
            "capacity": 2,
            "rentPerBed": 10000,
            "securityDeposit": 20000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "RA-103-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "RA-103-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 104",
        "flatType": "3BHK",
        "floor": "4th Floor",
        "rooms": [
          {
            "roomId": "RA-104-R1",
            "roomType": "2nd Master Bedroom",
            "capacity": 2,
            "rentPerBed": 10000,
            "securityDeposit": 20000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "RA-104-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "RA-104-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 101",
        "flatType": "3BHK",
        "floor": "1th Floor",
        "rooms": [
          {
            "roomId": "RA-101-R1",
            "roomType": "Common Bedroom",
            "capacity": 2,
            "rentPerBed": 9000,
            "securityDeposit": 18000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "RA-101-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "RA-101-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      },
      {
        "flatNumber": "Flat 102",
        "flatType": "3BHK",
        "floor": "2th Floor",
        "rooms": [
          {
            "roomId": "RA-102-R1",
            "roomType": "Hall Accommodation",
            "capacity": 2,
            "rentPerBed": 8000,
            "securityDeposit": 16000,
            "amenities": [
              "Individual Wardrobe",
              "High-Speed Wi-Fi",
              "Study Desk & Chair",
              "Daily Housekeeping",
              "24/7 Security"
            ],
            "beds": [
              {
                "bedId": "RA-102-R1-B1",
                "bedNumber": "Bed 1",
                "status": "Available",
                "residentId": null
              },
              {
                "bedId": "RA-102-R1-B2",
                "bedNumber": "Bed 2",
                "status": "Available",
                "residentId": null
              }
            ]
          }
        ]
      }
    ],
    "totalFlats": 4,
    "totalBeds": 8
  }
];
export default realProperties;
